<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />

    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="审核状态" prop="status">
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button :value="1"> 审核通过 </a-radio-button>
          <a-radio-button :value="2"> 审核未通过 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="审核说明" prop="auditingVal" v-if="form.status==2">
        <a-input v-model="form.auditingVal" placeholder="请输入" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, statusObj } from '@/api/pressure/carousel'
export default {
  name: 'CreateStatus',
  data() {
    return {
      submitLoading: false,
      showLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      // 表单参数
      form: {
        id: undefined,
        auditingVal: undefined,
        status: 1,
      },
      open: false,
      isShow: false,
      listType: [],
      inputVisible: false,
      inputVisibles: false,
      rules: {
        auditingVal: [{ required: true, message: '请输入说明', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {},
  watch: {},
  methods: {
    onClose() {
       const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
    // 取消按钮
    cancel() {
       this.onClose()
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        auditingVal: undefined,
        status: 1,
      }
      this.tags = []
      this.tagslist = []
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加轮播'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      this.form.id = postId
      this.formTitle = '审核'
      this.open = true
      // getObj(postId).then((response) => {
      //   console.log(response.data, 'response.data')
      //   // response.data.reservationTimes = [response.data.startTime, response.data.endTime]
      //   // this.form = response.data
      //   this.open = true
      //   this.formTitle = '修改轮播'
      // })
    },
    /** 提交按钮 */
    submitForm: function () {
       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
           this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          statusObj(this.form)
            .then((response) => {
              this.$message.success('审核成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
             const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  input {
    width: 30%;
    margin-right: 10px;
  }
}
</style>
